// extracted by mini-css-extract-plugin
export var divider = "_3l-0";
export var dividerText = "_3l-1";